module.exports = __webpack_public_path__ + "static/media/sally_chen.9497be0e.jpg";